<mat-tab-group>

  <mat-tab label="Personal Information">
    <form class="card-body" *ngIf="savedAnswersObj">    
      <!-- <div class="form-group ">
        <div class="row row-sm">
          <div class="col-md-3">
            <label class="form-label">Nombre de usuario</label>
          </div>
          <mat-form-field class="col-md-9" appearance="outline">
            <mat-label>Usuario:</mat-label>
            <input matInput placeholder="Nombre de usuario" class="form-control" type="text" name="username" [(ngModel)]="savedAnswersObj.username" required>
          </mat-form-field>
        </div>
      </div> -->

      <!-- NAME -->
      <mat-form-field class="form-field">
        <mat-label>Nombre:</mat-label>
        <input matInput placeholder="Nombre" type="text" name="name" [(ngModel)]="savedAnswersObj.name" required>
      </mat-form-field>
      <!-- LASTNAME -->
      <mat-form-field class="form-field">
        <mat-label>Apellido:</mat-label>
        <input matInput placeholder="Primer apellido" type="text" name="lastname" [(ngModel)]="savedAnswersObj.lastname" required>
      </mat-form-field>

      <mat-form-field class="form-field">
        <mat-label>Segundo Apellido:</mat-label>
        <input matInput placeholder="Segundo apellido" type="text" name="lastname2" [(ngModel)]="savedAnswersObj.lastname2" required>
      </mat-form-field>

      <mat-form-field class="form-field">
        <mat-label>Fecha Nacimiento:</mat-label>
        <input matInput [min]="minDate" [(ngModel)]="savedAnswersObj.birthday" [value]="savedAnswersObj.birthday" name="birthday" [max]="maxDate" [matDatepicker]="pickerC">
        <mat-datepicker-toggle matSuffix [for]="pickerC"></mat-datepicker-toggle>
        <mat-datepicker #pickerC></mat-datepicker>
      </mat-form-field>

    </form>
  </mat-tab> 

  <!-- TRIP DETAILS FORM -->
  <mat-tab label="Plans & Trip details">
    <form class="card-body">
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">¿Cuál es tu objetivo principal?</label>
        </div>
        <mat-form-field class="col-md-9" >
          <mat-label>Objetivo</mat-label>
          <input matInput type="text" placeholder="Ejm. Dar el siguiente paso en mi carrera profesional" [(ngModel)]="savedAnswersObj.goal" name="goal" required>
        </mat-form-field>
      </div>
  
      <!-- CIUDAD -->
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">¿A cuál ciudad quieres viajar?</label>
        </div>
        <mat-form-field class="form-field">
          <mat-label>Ciudad</mat-label>
          <mat-select [(ngModel)]="savedAnswersObj.destination" required name="destination">
              <mat-option *ngFor="let state of cities" [value]="state">{{state}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  
      <!-- FECHA DE SALIDA DEL PAIS -->
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Fecha de salida del país</label>
        </div>
        <mat-form-field class="form-field">
          <mat-label>Fecha de salida del país</mat-label>
          <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="pickerA" [(ngModel)]="savedAnswersObj.dateFrom" name="dateFrom">
          <mat-datepicker-toggle matSuffix [for]="pickerA"></mat-datepicker-toggle>
          <mat-datepicker #pickerA></mat-datepicker>
        </mat-form-field>
      </div>
  
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Te gustaría quedarte al finalizar:</label>
        </div>
        <div class="col-md-9">
          <mat-button-toggle-group style="margin: auto;" name="stayWorking" [(ngModel)]="savedAnswersObj.stayWorking">
            <mat-button-toggle [value]="'1'">Si</mat-button-toggle>
            <mat-button-toggle [value]="'0'">No</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
  
      <!-- FECHA DE REGRESO DEL PAIS -->
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Fecha de regreso estimada al país</label>
        </div>
        <mat-form-field class="col-md-9">
          <mat-label>Fecha de regreso</mat-label>
          <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="pickerB" [(ngModel)]="savedAnswersObj.dateTo" name="dateTo">
          <mat-datepicker-toggle matSuffix [for]="pickerB"></mat-datepicker-toggle>
          <mat-datepicker #pickerB></mat-datepicker>
        </mat-form-field>
      </div>
  
       <!-- UE PASSPORT -->
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">¿Tienes pasaporte Europeo?</label>
        </div>
        <div class="col-md-9" *ngIf="savedAnswersObj">
          <mat-button-toggle-group style="margin: auto;" name="uePassport" [(ngModel)]="savedAnswersObj.uePassport">
            <mat-button-toggle [value]="'1'">Si</mat-button-toggle>
            <mat-button-toggle [value]="'0'">No</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
  
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">¿Has viajado antes a Europa?</label>
        </div>
        <div class="col-md-9" *ngIf="savedAnswersObj">
          <mat-button-toggle-group style="margin: auto;" name="atEurope" [(ngModel)]="savedAnswersObj.atEurope">
            <mat-button-toggle [value]="'1'">Si</mat-button-toggle>
            <mat-button-toggle [value]="'0'">No</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
  
      <!-- HAVE YOU VISITED EUROPE PREVIOUSLY -->
      <div class="form-group " *ngIf="savedAnswersObj.atEurope == '1'">
        <div class="row row-sm">
          <div class="col-md-3">
            <label class="form-label">¿En cuáles ciudades has estado?</label>
          </div>
          <mat-form-field class="col-md-9">
            <mat-label>¿En cuáles ciudades has estado?</mat-label>
            <input matInput placeholder="Madrid, Londres" [(ngModel)]="savedAnswersObj.visitedCountries" name="visitedCountries">
          </mat-form-field>
        </div>
      </div>

    </form>
    
  </mat-tab>

  <!-- STUDENTS FORM -->
  <mat-tab label="Academic"> 

    <form class="card-body">
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">¿Tienes estudios universitarios?</label>
        </div>
        <div class="col-md-9" *ngIf="savedAnswersObj">
            <mat-button-toggle-group style="margin: auto;" name="studyHistory" [(ngModel)]="savedAnswersObj.studyHistory">
              <mat-button-toggle [value]="'finished'">Finalizados</mat-button-toggle>
              <mat-button-toggle [value]="'progress'">En curso</mat-button-toggle>
              <mat-button-toggle [value]="'none'">No</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
      </div>

      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Tipo de estudios a realizar</label>
        </div>
        <div class="col-md-9">
          <mat-select [(ngModel)]="savedAnswersObj.studyType" name="studyType">
            <mat-option *ngFor="let s of studies" [value]="s">{{s}}</mat-option>
        </mat-select>
        </div>
      </div>

      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">¿Has iniciado el proceso de búsqueda y contacto de Universidades/Centro de Estudios?</label>
        </div>
        <div class="col-md-9" *ngIf="savedAnswersObj">
          <mat-button-toggle-group style="margin: auto;" name="studySearch" [(ngModel)]="savedAnswersObj.studySearch">
            <mat-button-toggle [value]="'1'">Si</mat-button-toggle>
            <mat-button-toggle [value]="'0'">No</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

      <!-- FECHA DE INICIO DE LECCIONES -->
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Fecha de inicio de lecciones:</label>
        </div>
        <mat-form-field class="col-md-9">
          <mat-label>Inicio Lecciones</mat-label>
          <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="pickerStartLessons" [(ngModel)]="savedAnswersObj.startLessons" name="startLessons">
          <mat-datepicker-toggle matSuffix [for]="pickerStartLessons"></mat-datepicker-toggle>
          <mat-datepicker #pickerStartLessons></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Describe los estudios que quieres realizar:Describe los estudios que quieres realizar:</label>
        </div>
        <mat-form-field class="col-md-9">
          <mat-label>Estudios</mat-label>
          <input matInput placeholder="Ejm. Máster en mercadeo" [(ngModel)]="savedAnswersObj.studyDescription" name="studyDesc">
        </mat-form-field>
      </div>

      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Universidad</label>
        </div>
        <mat-form-field class="col-md-9">
          <mat-label>Universidad</mat-label>
          <input matInput placeholder="Ejm. Complutense" [(ngModel)]="savedAnswersObj.university" name="uni">
        </mat-form-field>
      </div>

      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Tienes la confirmación de la Universidad:</label>
        </div>
        <div class="col-md-9">
          <mat-button-toggle-group style="margin: auto;" name="studyConfirmation" [(ngModel)]="savedAnswersObj.studyConfirmation">
            <mat-button-toggle [value]="'1'">Si</mat-button-toggle>
            <mat-button-toggle [value]="'0'">No</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Has realizado el pago de la matrícula:</label>
        </div>
        <div class="col-md-9">
          <mat-button-toggle-group style="margin: auto;" name="tuitionPaid" [(ngModel)]="savedAnswersObj.tuitionPaid">
            <mat-button-toggle [value]="'1'">Si</mat-button-toggle>
            <mat-button-toggle [value]="'0'">No</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

    </form>
  </mat-tab>

  <!-- ABOUT YOU -->
  <mat-tab label="About you">

    <form class="card-body">
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">¿A qué te dedicas?</label>
        </div>
        <mat-form-field class="col-md-9">
          <mat-label>¿A qué te dedicas?</mat-label>
          <input matInput placeholder="Profesión o actividad principal" name="career" [(ngModel)]="savedAnswersObj.career" >
        </mat-form-field>
      </div>
  
      <!-- ABOUT YOU -->
      <div class="mb-4 main-content-label">About Yourself</div>
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Intereses adicionales:</label>
        </div>
        <mat-form-field appearance="fill" class="col-md-9">
          <mat-label>Detalles:</mat-label>
          <textarea matInput [(ngModel)]="savedAnswersObj.additionalInterests" name="additionalInterests"></textarea>
        </mat-form-field>
      </div>
  
      <!-- COMO NOS CONOCISTE -->
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">¿Cómo nos conociste?</label>
        </div>
        <mat-form-field class="col-md-9">
          <mat-label>¿Cómo nos conociste?</mat-label>
          <mat-select [(ngModel)]="savedAnswersObj.how" name="how">
              <mat-option *ngFor="let h of hows" [value]="h">{{h}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  
      <!-- PAIS -->
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">País</label>
        </div>
        <div class="col-md-9">
          <input type="text" class="form-control" [(ngModel)]="savedAnswersObj.country" name="country" placeholder="País" value="">
        </div>
      </div>
  
      <!-- COMENTARIOS ADICIONALES -->
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Comentarios adicionales</label>
        </div>
        <mat-form-field appearance="fill" class="col-md-9">
          <mat-label>Comentarios adicionales:</mat-label>
          <textarea matInput name="comments" [(ngModel)]="savedAnswersObj.comments" rows="6"></textarea>
        </mat-form-field>
      </div>
    </form>

  </mat-tab>

  <!-- CONTACT INFORMATION -->
  <mat-tab label="Contact information"> 
    <form class="card-body">

      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Email<i>(required)</i></label>
        </div>
        <div class="col-md-9">
          <app-email-input *ngIf="showEmailInput" (emailOutputData)="validateEmail($event)" [loadedEmail]="savedAnswersObj.email"></app-email-input>
        </div>
      </div>
  
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Phone</label>
        </div>
        <div class="col-md-9">
          <input type="text" class="form-control" [value]="savedAnswersObj.phone1" [(ngModel)]="savedAnswersObj.phone1" name="phone1">
        </div>
      </div>

      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Address</label>
        </div>
        <mat-form-field class="col-md-9">
          <mat-label>Dirección en España:</mat-label>
          <input matInput [value]="savedAnswersObj.address" class="form-control" name="address" [(ngModel)]="savedAnswersObj.address">
        </mat-form-field>
      </div>
  
      <!-- SOCIAL DETAILS -->
      <div class="mb-4 main-content-label">Social Info</div>
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Instagram</label>
        </div>
        <mat-form-field class="col-md-9">
          <mat-label>@usuario:</mat-label>
          <input matInput [value]="savedAnswersObj.instagram" class="form-control" name="ig" [(ngModel)]="savedAnswersObj.instagram">
        </mat-form-field>
      </div>
  
      <!-- FACEBOOK -->
      <div class="row row-sm">
        <div class="col-md-3">
          <label class="form-label">Facebook</label>
        </div>
        <div class="col-md-9">
          <input type="text" class="form-control" placeholder="facebook" value="https://www.facebook.com/Spruha">
        </div>
      </div>
    </form>
  </mat-tab>

  <mat-tab label="User config">
    <div class="row row-sm">
      
      <mat-form-field class="col-md-9">
        <mat-label>Asignado a</mat-label>
        <mat-select [(ngModel)]="savedAnswersObj.asignee" required name="asignee">
            <mat-option *ngFor="let asi of managers" [value]="asi">{{asi}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-tab>

</mat-tab-group>

<form class="form-horizontal" *ngIf="savedAnswersObj">
 <!--  
  <mat-form-field>
    <mat-label>Dirección en España:</mat-label>
    <input matInput [value]="savedAnswersObj.address" [(ngModel)]="savedAnswersObj.address">
  </mat-form-field>
-->
</form>

<!--BUTTON-->
<div class="margin-top-1rem"> <!--!isFormValid() || goal.invalid || name.invalid || lastname.invalid || destination.invalid -->
  <button *ngIf="!isUpdateMode()" [class]="getMainButtonCssClass()" mat-raised-button color="primary" [disabled]="!isFormValid()" (click)="saveNewLeadForm('create')">Save profile</button>
  <button *ngIf="isUpdateMode()" [class]="getMainButtonCssClass()" mat-raised-button color="primary" [disabled]="!isFormValid()" (click)="saveNewLeadForm('update')">Save changes</button>
</div>

<div class="card-body"><!--  *ngIf="isDebugMode() -->
  <h5>Debug:</h5>
  <span>{{ savedAnswersObj | json }}</span>
</div> 
